export default __webpack_public_path__ + "static/media/GHSI_Retirement_Policy.8e87fe12.pdf";